document.addEventListener("DOMContentLoaded", () => {
    const $videoOverviews = document.getElementById('videoOverviewContainer');
    if (!$videoOverviews) return;
    const videoItems = $videoOverviews.querySelectorAll('.video-item');
    const increment = parseInt($videoOverviews.dataset.visible || '15');
    const loadMoreBtn = document.getElementById('loadMore');
    let currentIndex = increment;


    function showNextBlocks() {
        loadMoreBtn.disabled = true;

        let delay = 0;
        for (let i = currentIndex; i < currentIndex + increment && i < videoItems.length; i++) {
            setTimeout(() => {
                videoItems[i].classList.remove('is-hidden-soft');
            }, delay);
            delay += 200;
        }

        currentIndex += increment;

        setTimeout(() => {
            if (currentIndex >= videoItems.length) {
                loadMoreBtn.classList.add('is-hidden');
            }
            loadMoreBtn.disabled = false;
        }, delay);
    }


    loadMoreBtn.addEventListener('click', showNextBlocks);
});
